<template>
  <v-main class="full-screen-layout" :id="routeId">
    <router-view />
  </v-main>
</template>

<script setup>
  import { useAppStore } from '@/stores/app'
  const appStore = useAppStore()
  const route = useRoute()

  const routeId = computed(() => route.path.replace(/\//g, '_').replace(/^_/, ''))
</script>

<style lang="scss">
.full-screen-layout {
}
</style>
